import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DialogName, Prefecture, TokenInfo } from 'interface'
import { VariantType } from 'notistack'
import axiosClient from 'utils/axiosClient'

const initialState: {
  auth?: TokenInfo
  status: 'init' | 'loading' | 'fulfilled'
  snackbarMessage?: {
    text: string
    type: VariantType
  }
  notice: string
  dialogName: DialogName
  prefectures: Prefecture[]
} = {
  notice: '',
  dialogName: '',
  status: 'init',
  prefectures: [],
}

export const getAuth = createAsyncThunk('UI/getAuth', async () => {
  const { data } = await axiosClient.get('/auth/user')
  return data
})
export const logout = createAsyncThunk('UI/logout', async () => {
  await axiosClient.post('/auth/logout')
})
export const getPrefectures = createAsyncThunk('UI/prefectures', async () => {
  const { data } = await axiosClient.get('/api/prefectures')
  return data
})

export const UISlice = createSlice({
  name: 'UI',
  initialState,
  reducers: {
    setAuth(state, { payload }: PayloadAction<TokenInfo>) {
      state.auth = payload
    },
    setSnackbarMessage(
      state,
      {
        payload,
      }: PayloadAction<
        | {
            text: string
            type: VariantType
          }
        | undefined
      >
    ) {
      state.snackbarMessage = payload
    },
    setNotice(state, { payload }: PayloadAction<string>) {
      state.notice = payload
    },
    setDialogName(state, { payload }: PayloadAction<DialogName>) {
      state.dialogName = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAuth.fulfilled, (state, { payload }) => {
      state.status = 'fulfilled'
      if (payload.id) {
        state.auth = payload
      }
    })
    builder.addCase(logout.fulfilled, (state, { payload }) => {
      state.auth = undefined
    })
    builder.addCase(getPrefectures.fulfilled, (state, { payload }) => {
      state.prefectures = payload
    })
  },
})

export const UIAction = UISlice.actions

export const UIReducer = UISlice.reducer
